var map = {
	"./book_diligence_a_teachings.png": 759,
	"./book_diligence_b_guide.png": 760,
	"./book_diligence_c_philosophies.png": 761,
	"./book_freedom_a_teachings.png": 762,
	"./book_freedom_b_guide.png": 763,
	"./book_freedom_c_philosophies.png": 764,
	"./boss_dvalin_claw.png": 765,
	"./boss_dvalin_plume.png": 766,
	"./boss_dvalin_sigh.png": 767,
	"./boss_tartaglia_shadow.png": 768,
	"./boss_tartaglia_shard.png": 769,
	"./boss_tartaglia_tusk.png": 770,
	"./crown.png": 343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 758;